import environment from "../../../environment/environment";
import routes from "../common/api-routes";
import {HttpGet} from "../common/HttpRequestBuilder";

const SUBSCRIPTION_KEY = environment.service_baseUrl.subscriptionKey;

const getTotalVerification = () => {

    let parameters = null;
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_TOTAL_VERIFICATION, parameters, subscriptionKey);
    return result;
}

const getTotalVerificationByDateRange = (startDate, endDate) => {

    let query_params = {
        startDate: startDate,
        endDate: endDate
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_TOTAL_VERIFICATION_DATE_RANGE, query_params, subscriptionKey);
    return result;
}

const getVerificationCount = (startDate, endDate) => {

    let query_params = {
        startDate: startDate,
        endDate: endDate
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_VERIFICATION_COUNT, query_params, subscriptionKey);
    return result;
}

const getTopVerificationProducts = (startDate, endDate) => {

    let query_params = {
        startDate: startDate,
        endDate: endDate
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_TOP_VERIFICATION_PRODUCTS, query_params, subscriptionKey);
    return result;
}

const getTotalVerificationPerHour = (startDate, endDate) => {
    let query_params = {
        startDate: startDate,
        endDate: endDate
    }
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_TOTAL_VERIFICATION_PER_HOUR, query_params, subscriptionKey);
    return result;
}

const getDashboardTotalAuthenticationByStatus = () => {

    let parameters = null;

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_DASHBOARD_TOTAL_AUTHENTICATION_BY_STATUS, parameters, subscriptionKey);
    return result;
}

const getDashboardAuthenticationStatus = (startDate, endDate) => {

    let query_params = {
        startDate: startDate,
        endDate: endDate
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_DASHBOARD_AUTHENTICATION_STATUS, query_params, subscriptionKey);
    return result;
}

const getDashboardAuthenticationCount = (startDate, endDate) => {

    let query_params = {
        startDate: startDate,
        endDate: endDate
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_DASHBOARD_AUTHENTICATION_COUNT, query_params, subscriptionKey);
    return result;
}

const getTotalAuthenticationPerHour = (startDate, endDate) => {

    let query_params = {
        startDate: startDate,
        endDate: endDate
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_TOTAL_AUTHENTICATION_PER_HOUR, query_params, subscriptionKey);
    return result;
}

const getTopProductAnomalies = (startDate, endDate, top) => {

    let query_params = {
        startDate: startDate,
        endDate: endDate, 
        top: top       
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_DASHBOARD_TOP_PRODUCTS_ANOMALIES, query_params, subscriptionKey);
    return result;
}

const getProductAnomalyDetection = (startDate, endDate, top) => {

    let query_params = {
        startDate: startDate,
        endDate: endDate, 
        top: top       
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_DASHBOARD_PRODUCT_ANOMALY_DETECTION, query_params, subscriptionKey);
    return result;
}

const getGeolocationDistribution = (parameters) => {
    let query_params = parameters;
    let subscriptionKey = SUBSCRIPTION_KEY;
    
    let result = HttpGet(routes.GET_GEOLOCATION_DISTRIBUTION, query_params, subscriptionKey);
    return result;
}

const getGeolocationDistributionFilterByCountry = (parameters) => {

    let query_params = parameters;
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_GEOLOCATION_DISTRIBUTION, query_params, subscriptionKey);
    return result;
}

const getVerificationStatusGraph = (startDate, endDate) => {

    let query_params = {
        startDate: startDate,
        endDate: endDate
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_VERIFICATION_STATUS_GRAPH, query_params, subscriptionKey);
    return result;
}

const getDashboardVerificationOverview = () => {

    let parameters = null;

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_DASHBOARD_VERIFICATION_OVERVIEW, parameters, subscriptionKey);
    return result;
}


const DashboardService = {
    getTotalVerification,
    getTotalVerificationByDateRange,
    getVerificationCount,
    getTopVerificationProducts,
    getTotalVerificationPerHour,
    getDashboardTotalAuthenticationByStatus,
    getDashboardAuthenticationStatus,
    getDashboardAuthenticationCount,
    getTotalAuthenticationPerHour,
    getTopProductAnomalies,
    getProductAnomalyDetection,
    getGeolocationDistribution,
    getGeolocationDistributionFilterByCountry,
    getVerificationStatusGraph,
    getDashboardVerificationOverview,
}

export default DashboardService
